import { Font } from "@/services/fonts/types";
import Api from "@/services/api";
import { FILEENDPOINT } from "@/app.config";

export async function getAllFonts(): Promise<Font[]> {
    return new Promise((resolve, reject) => {
        Api.get("/fonts").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function saveFont(model: FormData): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/fonts", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteFont(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete("/fonts/" + id).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function changeStatus(model: Font): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/fonts/changestatus", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getWebFonts(): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.get("/fonts/webfonts").then(
            response => {
                resolve(response.data.map((x: any) => {
                    return `@font-face { font-family: '${x.fontFamily}';` + `src: url('${FILEENDPOINT}${x.id}/${x.type}');}`;
                }).join(" "));
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function LoadCustomWebFonts() {
    const customWebFontsString = await getWebFonts();
    const existingStyleElement = document.head.getElementsByClassName("font-style")[0];
    if (existingStyleElement) {
        existingStyleElement.innerHTML = customWebFontsString;
    } else {
        const style = document.createElement("style");
        style.classList.add("font-style");
        style.innerHTML = customWebFontsString;
        document.head.appendChild(style);
    }
}
